import { cn } from '~/common/utils/styleUtil';
import { FaPhone } from 'react-icons/fa';
import { webshopConfig } from '~/config/webshopConfig';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function KundencenterTel({ className }: Readonly<{ className?: string }>) {
  return (
    <TrackNavigationClick label={webshopConfig.kundencenterFooterLink.titleKey}>
      <a
        href={webshopConfig.kundencenterFooterLink.urlDe}
        target={'_blank'}
        className={cn(
          'flex items-center hover:text-primary text-black desktop:text-secondary desktop:hover:text-primary desktop:px-2 h-12',
          className
        )}
        data-testid={'kundencenter-tel-link'}
      >
        <FaPhone size={14} />
        <div className={'ml-2 text-base desktop:text-sm desktop:ml-1'}>
          {webshopConfig.kundencenterFooterLink.titleKey}
        </div>
      </a>
    </TrackNavigationClick>
  );
}
